// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"323":"b7098971","898":"05a3e24a"}[chunkId] + ".css";
};